import React, {Component} from 'react';
import {Prompt} from 'react-router-dom';

import san from '../../utils/sanitiser.js';

import Validator from './validator.js';

import Item from './item.js';
import ItemPending from './item-pending.js';
import ItemFetchError from './item-fetch-error.js';

export default class Parent extends Component {

  constructor(props) {
    super(props);
    this.state = {
      item: null,
      fetchError: null,
      newType: 'drop_down',
      beenSaved: false,
    };
    this.untouchedData = null;
    this.match = this.props.match;
    this.gatekeeper = this.props.gatekeeper;

    this.pricePattern = /^(\d+(\.(\d(\d)?)?)?)?$/;

    this.renderItemAndCustomisations = this.renderItemAndCustomisations.bind(this);
    this.renderPending = this.renderPending.bind(this);
    this.renderFetchError = this.renderFetchError.bind(this);
    this.changeNewType = this.changeNewType.bind(this);
    this.addNewRequiredTextField = this.addNewRequiredTextField.bind(this);
    this.addNewOptionalTextField = this.addNewOptionalTextField.bind(this);
    this.addNewDropDownField = this.addNewDropDownField.bind(this);
    this.addNewDropDownOption = this.addNewDropDownOption.bind(this);
    this.deleteDropDownOption = this.deleteDropDownOption.bind(this);
    this.changeName = this.changeName.bind(this);
    this.changeLabel = this.changeLabel.bind(this);
    this.changePrice = this.changePrice.bind(this);
    this.deleteCustomisation = this.deleteCustomisation.bind(this);
    this.changeOptionValue = this.changeOptionValue.bind(this);
    this.changeOptionPrice = this.changeOptionPrice.bind(this);
    this.saveCustomisations = this.saveCustomisations.bind(this);
    this.touched = this.touched.bind(this);
    this.validate = this.validate.bind(this);

    this._onUnload = this._onUnload.bind(this);
  }

  _onUnload(event) {
    if (this.safeTouched()) {
      event.preventDefault();
    }
  }

  _transformItemDataFromBackend(data) {
    const acc = [];
    data.customisations.forEach(cust => {
      if (cust.type === 'optional_text') {
        cust.price = cust.price === undefined ? '' : cust.price.toFixed(2);
      }
      if (cust.options !== undefined) {
        const opts = [];
        cust.options.forEach(opt => {
          opt.price = opt.price === undefined ? '' : opt.price.toFixed(2);
          opts.push(opt);
        });
        cust.options = opts;
      }
      acc.push(cust);
    });
    return { ...data, customisations: acc };
  }

  async componentDidMount() {
    window.addEventListener('beforeunload', this._onUnload);
    try {
      const apiData = await this.gatekeeper.getData(this.match.params.id);
      const data = this._transformItemDataFromBackend(apiData);
      this.untouchedData = JSON.stringify(data.customisations);
      this.setState({ ...this.state, item: data });
    } catch (err) {
      console.error('Error: ', err);
      this.setState({ ...this.state, fetchError: err });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this._onUnload);
  }

  changeNewType(val) {
    this.setState({ ...this.state, newType: val });
  }

  _nextIndexFor(indexedCollection) {
    return (
      indexedCollection.reduce(
        (acc, curr) => curr.index > acc ? curr.index : acc,
        -1
      ) + 1
    );
  }

  _nextIndex() {
    return this._nextIndexFor(this.state.item.customisations);
  }

  addNewRequiredTextField() {
    const customisations = this.state.item.customisations;
    customisations.push({
      index: this._nextIndex(),
      type: 'required_text',
      name: '',
      label: '',
    });
    this.setState({
      ...this.state,
      item: { ...this.state.item, customisations: customisations },
    });
  }

  addNewOptionalTextField() {
    const customisations = this.state.item.customisations;
    customisations.push({
      index: this._nextIndex(),
      type: 'optional_text',
      name: '',
      label: '',
      price: '',
    });
    this.setState({
      ...this.state,
      item: { ...this.state.item, customisations: customisations },
    });
  }

  addNewDropDownField() {
    const customisations = this.state.item.customisations;
    customisations.push({
      index: this._nextIndex(),
      type: 'drop_down',
      name: '',
      label: '',
      options: [
        { index: 0, value: '', price: '' },
        { index: 1, value: '', price: '' },
      ]
    });
    this.setState({
      ...this.state,
      item: { ...this.state.item, customisations: customisations },
    });
  }

  addNewDropDownOption(index) {
    const customisations = this.state.item.customisations;
    const i = customisations.findIndex(e => e.index === index);
    if (i === -1) return;
    const cust = customisations[i];
    if (cust.options === undefined) return;
    cust.options.push({
      index: this._nextIndexFor(cust.options),
      value: '',
      price: '',
    });
    customisations.splice(i, 1, cust);
    this.setState({
      ...this.state,
      item: { ...this.state.item, customisations: customisations },
    });
  }

  deleteDropDownOption(cindex, oindex) {
    const custs = this.state.item.customisations;
    const i = custs.findIndex(e => e.index === cindex);
    if (i === -1) return;
    const cust = custs[i];
    if (cust.options === undefined) return;
    const j = cust.options.findIndex(e => e.index === oindex);
    if (j === -1) return;
    cust.options.splice(j, 1);
    this.setState({
      ...this.state,
      item: { ...this.state.item, customisations: custs },
    });
  }

  _changeIndexedKeyedValue(index, key, value) {
    const customisations = this.state.item.customisations;
    const i = customisations.findIndex(e => e.index === index);
    if (i === -1) return;
    const customisation = customisations[i];
    customisation[key] = value;
    customisations.splice(i, 1, customisation);
    this.setState({
      ...this.state,
      item: { ...this.state.item, customisations: customisations },
    });
  }

  changeName(index, value) {
    this._changeIndexedKeyedValue(index, 'name', value);
  }
  
  changeLabel(index, value) {
    this._changeIndexedKeyedValue(index, 'label', value);
  }

  changePrice(index, value) {
    if (this.pricePattern.exec(value)) {
      this._changeIndexedKeyedValue(index, 'price', value);
    }
  }

  _changeIndexedKeyedOptionValue(cindex, oindex, key, value) {
    const customisations = this.state.item.customisations;
    const i = customisations.findIndex(e => e.index === cindex);
    if (i === -1) return;
    const customisation = customisations[i];
    const options = customisation.options;
    if (options === undefined) return;
    const j = options.findIndex(e => e.index === oindex);
    if (j === -1) return;
    const option = options[j];
    option[key] = value;
    options.splice(j, 1, option);
    customisation.options = options;
    customisations.splice(i, 1, customisation);
    this.setState({
      ...this.state,
      item: { ...this.state.item, customisations: customisations },
    });
  }

  changeOptionValue(cindex, oindex, value) {
    this._changeIndexedKeyedOptionValue(cindex, oindex, 'value', value);
  }

  changeOptionPrice(cindex, oindex, value) {
    if (this.pricePattern.exec(value)) {
      this._changeIndexedKeyedOptionValue(cindex, oindex, 'price', value);
    }
  }

  deleteCustomisation(index) {
    const customisations = this.state.item.customisations;
    const i = customisations.findIndex(e => e.index === index);
    if (i !== -1) {
      customisations.splice(i, 1);
      this.setState({
        ...this.state,
        item: { ...this.state.item, customisations: customisations },
      });
    } else {
      console.error(`Could not find object with index ${ index }`);
    }
  }

  _transformCustomisationDataForSaving(data) {
    const r = [];
    for (let i = 0; i < data.length; i ++) {
      const cust = data[i];
      const rcust = {};
      rcust.type = cust.type;
      rcust.name = san(cust.name);
      rcust.label = san(cust.label);
      let price = parseFloat(cust.price);
      if (!isNaN(price) && price !== 0) { rcust.price = price; }
      if (cust.options !== undefined) {
        const ropts = [];
        for (let j = 0; j < cust.options.length; j ++) {
          const opt = cust.options[j];
          const ropt = {};
          ropt.value = san(opt.value);
          price = parseFloat(opt.price);
          if (!isNaN(price) && price !== 0) { ropt.price = price; }
          ropts.push(ropt);
        }
        rcust.options = ropts;
      }
      r.push(rcust);
    }
    return r;
  }

  async saveCustomisations() {
    try {
      const apiData = await this.gatekeeper.saveData(
        this.match.params.id,
        this._transformCustomisationDataForSaving(this.state.item.customisations),
      );
      const data = this._transformItemDataFromBackend(apiData);
      this.untouchedData = JSON.stringify(data.customisations);
      this.setState({ ...this.state, item: data, beenSaved: true });
    } catch (err) {
      console.error('Error: ', err);
      this.setState({ ...this.state, fetchError: err });
    }
  }

  touched() {
    return JSON.stringify(this.state.item.customisations) !== this.untouchedData;
  }

  safeTouched() {
    return this.state.item ? this.touched() : false;
  }

  validate() {
    return Validator.validate(this.state.item.customisations);
  }

  renderPrompt() {
    if (this.props.testing === true ) {
      return null;
    } else {
      return (
        <Prompt
          when={this.safeTouched()}
          message="You have unsaved data. Are you sure you want to leave?"
        />
      );
    }
  }

  renderItemAndCustomisations() {
    return <Item
      item={this.state.item}
      newType={this.state.newType}
      changeNewType={this.changeNewType}
      addNewRequiredTextField={this.addNewRequiredTextField}
      addNewOptionalTextField={this.addNewOptionalTextField}
      addNewDropDownField={this.addNewDropDownField}
      changeName={this.changeName}
      changeLabel={this.changeLabel}
      changePrice={this.changePrice}
      addNewDropDownOption={this.addNewDropDownOption}
      deleteDropDownOption={this.deleteDropDownOption}
      changeOptionValue={this.changeOptionValue}
      changeOptionPrice={this.changeOptionPrice}
      deleteCustomisation={this.deleteCustomisation}
      saveCustomisations={this.saveCustomisations}
      touched={this.touched}
      beenSaved={this.state.beenSaved}
      validate={this.validate}
    />;
  }

  renderPending() {
    return <ItemPending/>;
  }

  renderFetchError() {
    window.location = this.props.endpoints.login();
    // return <ItemFetchError/>
  }

  render() {
    let childComponentFunc;
    if (this.state.fetchError) {
      childComponentFunc = this.renderFetchError;
    } else if (this.state.item) {
      childComponentFunc = this.renderItemAndCustomisations;
    } else {
      childComponentFunc = this.renderPending;
    }
    return (
      <section className="ItemCustomisations">
        {this.renderPrompt()}
        {childComponentFunc()}
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/item-customisations/parent.js